export default "__VITE_ASSET__ArNkPlH1__"